export const quiz = {
  "appLocale": {
    "landingHeaderText": "PHP Assessment (<questionLength> Questions)",
    "question": "Question",
    "startQuizBtn": "Start Assessment",
    "resultFilterAll": "All",
    "resultFilterCorrect": "Correct",
    "resultFilterIncorrect": "Incorrect",
    "prevQuestionBtn": "Prev",
    "nextQuestionBtn": "Next",
    "resultPageHeaderText": "You have completed the assessment. You got <correctIndexLength> out of <questionLength> questions."
  },

  "quizTitle": "PHP",
  "quizSynopsis": "This assessment tests your understanding of PHP fundamentals, syntax, functions, arrays, objects, OOP, superglobals, and more.",
  "nrOfQuestions": "50",
  "questions": [
    {
      "question": "What does PHP stand for?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "Private Home Page",
        "Personal Hypertext Processor",
        "PHP: Hypertext Preprocessor",
        "Preprocessed Hypertext Page"
      ],
      "correctAnswer": "3",
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "PHP stands for PHP: Hypertext Preprocessor.",
      "point": "2"
    },
    {
      "question": "Which symbol is used to start a PHP block?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": ["<?php", "<script>", "<?", "<%php%>"],
      "correctAnswer": "1",
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "PHP code is enclosed within <?php ... ?> tags.",
      "point": "2"
    },
    {
      "question": "Which of the following are valid PHP data types?",
      "questionType": "text",
      "answerSelectionType": "multiple",
      "answers": ["String", "Integer", "Boolean", "Character"],
      "correctAnswer": [1, 2, 3],
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "PHP does not have a character type; strings are used instead.",
      "point": "2"
    },
    {
      "question": "How do you declare a variable in PHP?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": ["$variable", "var variable", "let variable", "#variable"],
      "correctAnswer": "1",
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "PHP variables start with a $ sign.",
      "point": "2"
    },
    {
      "question": "Which of the following are valid ways to declare constants in PHP?",
      "questionType": "text",
      "answerSelectionType": "multiple",
      "answers": ["define()", "const keyword", "var keyword", "setConstant()"],
      "correctAnswer": [1, 2],
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "Constants can be declared using define() or const.",
      "point": "2"
    },
    {
      "question": "Which operator is used for concatenation in PHP?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": ["+", ".", "&", "concat()"],
      "correctAnswer": "2",
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "The dot (.) operator concatenates strings in PHP.",
      "point": "2"
    },
    {
      "question": "Which function outputs text in PHP?",
      "questionType": "text",
      "answerSelectionType": "multiple",
      "answers": ["echo", "print", "console.log", "printf"],
      "correctAnswer": [1, 2, 4],
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "echo, print, and printf can output text in PHP.",
      "point": "2"
    },
    {
      "question": "Which of the following are valid PHP comparison operators?",
      "questionType": "text",
      "answerSelectionType": "multiple",
      "answers": ["==", "===", "!=", "><"],
      "correctAnswer": [1, 2, 3],
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": ">< is invalid in PHP; the others are valid comparison operators.",
      "point": "2"
    },
    {
      "question": "Which of the following are valid loop types in PHP?",
      "questionType": "text",
      "answerSelectionType": "multiple",
      "answers": ["for", "while", "foreach", "loop"],
      "correctAnswer": [1, 2, 3],
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "'loop' is not a PHP keyword; for, while, and foreach are valid loops.",
      "point": "2"
    },
    {
      "question": "Which function converts an array to a JSON string in PHP?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": ["json_encode()", "json_parse()", "toJSON()", "array_to_json()"],
      "correctAnswer": "1",
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "json_encode() converts an array or object to a JSON string.",
      "point": "2"
    },
    {
      "question": "Which function converts a JSON string to a PHP array?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": ["json_decode()", "json_parse()", "toArray()", "decode_json()"],
      "correctAnswer": "1",
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "json_decode() converts JSON string into a PHP object or array.",
      "point": "2"
    },
    {
      "question": "Which of the following are PHP superglobals?",
      "questionType": "text",
      "answerSelectionType": "multiple",
      "answers": ["$_GET", "$_POST", "$_SERVER", "$_VAR"],
      "correctAnswer": [1, 2, 3],
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "$_GET, $_POST, $_SERVER are superglobals; $_VAR is not.",
      "point": "2"
    },
    {
      "question": "Which of the following are valid ways to define a function in PHP?",
      "questionType": "text",
      "answerSelectionType": "multiple",
      "answers": ["function keyword", "fn keyword", "arrow function", "def keyword"],
      "correctAnswer": [1, 2],
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "PHP 7.4+ supports fn keyword for arrow functions; 'def' does not exist.",
      "point": "2"
    },
    {
      "question": "Which operator is used for identity comparison in PHP?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": ["==", "===", "!=", "==="],
      "correctAnswer": "2",
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "=== checks both value and type in PHP.",
      "point": "2"
    },
    {
      "question": "Which of the following are valid array functions in PHP?",
      "questionType": "text",
      "answerSelectionType": "multiple",
      "answers": ["array_push()", "array_pop()", "push_array()", "count()"],
      "correctAnswer": [1, 2, 4],
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "array_push(), array_pop(), count() are valid; push_array() is not.",
      "point": "2"
    },
    {
      "question": "Which of the following are ways to start a session in PHP?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": ["session_start()", "start_session()", "init_session()", "begin_session()"],
      "correctAnswer": "1",
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "session_start() initializes a PHP session.",
      "point": "2"
    },
    {
      "question": "Which function checks if a variable is set?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": ["isset()", "empty()", "defined()", "check()"],
      "correctAnswer": "1",
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "isset() checks if a variable is declared and is not null.",
      "point": "2"
    },
    {
      "question": "Which of the following are valid ways to include files in PHP?",
      "questionType": "text",
      "answerSelectionType": "multiple",
      "answers": ["include", "require", "import", "include_once"],
      "correctAnswer": [1, 2, 4],
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "include, require, include_once are valid; import is not PHP syntax.",
      "point": "2"
    },
    {
      "question": "Which function returns the length of a string in PHP?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": ["strlen()", "size()", "length()", "strlength()"],
      "correctAnswer": "1",
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "strlen() returns the number of characters in a string.",
      "point": "2"
    },
   
{
  "question": "Which of the following are PHP loop types?",
  "questionType": "text",
  "answerSelectionType": "multiple",
  "answers": ["for", "while", "do...while", "foreach"],
  "correctAnswer": [1, 2, 3, 4],
  "messageForCorrectAnswer": "Correct.",
  "messageForIncorrectAnswer": "Incorrect.",
  "explanation": "PHP supports for, while, do...while, and foreach loops.",
  "point": "2"
},
{
  "question": "Which function is used to open a file in PHP?",
  "questionType": "text",
  "answerSelectionType": "single",
  "answers": ["fopen()", "open()", "file_open()", "readFile()"],
  "correctAnswer": "1",
  "messageForCorrectAnswer": "Correct.",
  "messageForIncorrectAnswer": "Incorrect.",
  "explanation": "fopen() opens a file for reading or writing.",
  "point": "2"
},
{
  "question": "Which function writes data to a file in PHP?",
  "questionType": "text",
  "answerSelectionType": "single",
  "answers": ["fwrite()", "write()", "file_write()", "echo()"],
  "correctAnswer": "1",
  "messageForCorrectAnswer": "Correct.",
  "messageForIncorrectAnswer": "Incorrect.",
  "explanation": "fwrite() writes data to a file opened by fopen().",
  "point": "2"
},
{
  "question": "Which of the following are PHP object-oriented programming features?",
  "questionType": "text",
  "answerSelectionType": "multiple",
  "answers": ["Class", "Object", "Inheritance", "Interface"],
  "correctAnswer": [1, 2, 3, 4],
  "messageForCorrectAnswer": "Correct.",
  "messageForIncorrectAnswer": "Incorrect.",
  "explanation": "PHP supports OOP with classes, objects, inheritance, and interfaces.",
  "point": "2"
},
{
  "question": "Which keyword is used to create a class in PHP?",
  "questionType": "text",
  "answerSelectionType": "single",
  "answers": ["function", "class", "object", "define"],
  "correctAnswer": "2",
  "messageForCorrectAnswer": "Correct.",
  "messageForIncorrectAnswer": "Incorrect.",
  "explanation": "The 'class' keyword is used to define classes in PHP.",
  "point": "2"
},
{
  "question": "Which keyword is used to inherit a class in PHP?",
  "questionType": "text",
  "answerSelectionType": "single",
  "answers": ["implements", "extends", "inherits", "use"],
  "correctAnswer": "2",
  "messageForCorrectAnswer": "Correct.",
  "messageForIncorrectAnswer": "Incorrect.",
  "explanation": "'extends' is used to inherit a parent class.",
  "point": "2"
},
{
  "question": "Which of the following are PHP magic methods?",
  "questionType": "text",
  "answerSelectionType": "multiple",
  "answers": ["__construct()", "__destruct()", "__get()", "__set()"],
  "correctAnswer": [1, 2, 3, 4],
  "messageForCorrectAnswer": "Correct.",
  "messageForIncorrectAnswer": "Incorrect.",
  "explanation": "These are built-in magic methods used in PHP OOP.",
  "point": "2"
},
{
  "question": "Which of the following is used for exception handling in PHP?",
  "questionType": "text",
  "answerSelectionType": "multiple",
  "answers": ["try", "catch", "throw", "finally"],
  "correctAnswer": [1, 2, 3, 4],
  "messageForCorrectAnswer": "Correct.",
  "messageForIncorrectAnswer": "Incorrect.",
  "explanation": "All these keywords are used in PHP exception handling.",
  "point": "2"
},
{
  "question": "Which operator is used for concatenating strings in PHP?",
  "questionType": "text",
  "answerSelectionType": "single",
  "answers": ["+", ".", "&", "concat()"],
  "correctAnswer": "2",
  "messageForCorrectAnswer": "Correct.",
  "messageForIncorrectAnswer": "Incorrect.",
  "explanation": "The dot (.) operator concatenates strings.",
  "point": "2"
},
{
  "question": "Which of the following are PHP comparison operators?",
  "questionType": "text",
  "answerSelectionType": "multiple",
  "answers": ["==", "===", "!=", "<>", "><"],
  "correctAnswer": [1, 2, 3, 4],
  "messageForCorrectAnswer": "Correct.",
  "messageForIncorrectAnswer": "Incorrect.",
  "explanation": "==, ===, !=, <> are valid comparison operators; >< is invalid.",
  "point": "2"
},
{
  "question": "Which of the following are PHP superglobals?",
  "questionType": "text",
  "answerSelectionType": "multiple",
  "answers": ["$_GET", "$_POST", "$_COOKIE", "$_SESSION", "$_VAR"],
  "correctAnswer": [1, 2, 3, 4],
  "messageForCorrectAnswer": "Correct.",
  "messageForIncorrectAnswer": "Incorrect.",
  "explanation": "$_GET, $_POST, $_COOKIE, $_SESSION are valid superglobals.",
  "point": "2"
},
{
  "question": "Which function is used to check if a variable is empty?",
  "questionType": "text",
  "answerSelectionType": "single",
  "answers": ["isset()", "empty()", "is_null()", "check()"],
  "correctAnswer": "2",
  "messageForCorrectAnswer": "Correct.",
  "messageForIncorrectAnswer": "Incorrect.",
  "explanation": "empty() checks if a variable is empty or 0 or null.",
  "point": "2"
},
{
  "question": "Which of the following are valid PHP array functions?",
  "questionType": "text",
  "answerSelectionType": "multiple",
  "answers": ["array_push()", "array_pop()", "array_merge()", "count()"],
  "correctAnswer": [1, 2, 3, 4],
  "messageForCorrectAnswer": "Correct.",
  "messageForIncorrectAnswer": "Incorrect.",
  "explanation": "All listed functions are valid array functions.",
  "point": "2"
},
{
  "question": "Which function is used to start a session in PHP?",
  "questionType": "text",
  "answerSelectionType": "single",
  "answers": ["session_start()", "start_session()", "begin_session()", "init_session()"],
  "correctAnswer": "1",
  "messageForCorrectAnswer": "Correct.",
  "messageForIncorrectAnswer": "Incorrect.",
  "explanation": "session_start() initializes a PHP session.",
  "point": "2"
},
{
  "question": "Which function destroys a session in PHP?",
  "questionType": "text",
  "answerSelectionType": "single",
  "answers": ["session_destroy()", "end_session()", "close_session()", "destroy_session()"],
  "correctAnswer": "1",
  "messageForCorrectAnswer": "Correct.",
  "messageForIncorrectAnswer": "Incorrect.",
  "explanation": "session_destroy() ends a PHP session.",
  "point": "2"
},
{
  "question": "Which function sets a cookie in PHP?",
  "questionType": "text",
  "answerSelectionType": "single",
  "answers": ["setcookie()", "cookie_set()", "create_cookie()", "cookie()"],
  "correctAnswer": "1",
  "messageForCorrectAnswer": "Correct.",
  "messageForIncorrectAnswer": "Incorrect.",
  "explanation": "setcookie() sets a cookie in the browser.",
  "point": "2"
},
{
  "question": "Which of the following are valid ways to include files in PHP?",
  "questionType": "text",
  "answerSelectionType": "multiple",
  "answers": ["include()", "require()", "include_once()", "require_once()"],
  "correctAnswer": [1, 2, 3, 4],
  "messageForCorrectAnswer": "Correct.",
  "messageForIncorrectAnswer": "Incorrect.",
  "explanation": "All listed methods can include files in PHP.",
  "point": "2"
},
{
  "question": "Which of the following are valid ways to define a constant in PHP?",
  "questionType": "text",
  "answerSelectionType": "multiple",
  "answers": ["define()", "const keyword", "setConstant()", "constant()"],
  "correctAnswer": [1, 2],
  "messageForCorrectAnswer": "Correct.",
  "messageForIncorrectAnswer": "Incorrect.",
  "explanation": "Constants can be declared with define() or const; the others are invalid.",
  "point": "2"
},
{
  "question": "Which function is used to filter and sanitize input data in PHP?",
  "questionType": "text",
  "answerSelectionType": "multiple",
  "answers": ["filter_var()", "htmlspecialchars()", "sanitize_input()", "filter_input()"],
  "correctAnswer": [1, 2, 4],
  "messageForCorrectAnswer": "Correct.",
  "messageForIncorrectAnswer": "Incorrect.",
  "explanation": "filter_var(), htmlspecialchars(), and filter_input() are standard sanitization functions.",
  "point": "2"
},
{
  "question": "Which of the following are valid ways to handle errors in PHP?",
  "questionType": "text",
  "answerSelectionType": "multiple",
  "answers": ["try...catch", "set_error_handler()", "error_reporting()", "ignore_error()"],
  "correctAnswer": [1, 2, 3],
  "messageForCorrectAnswer": "Correct.",
  "messageForIncorrectAnswer": "Incorrect.",
  "explanation": "ignore_error() does not exist; the others are valid.",
  "point": "2"
},
{
  "question": "Which of the following are PHP namespaces features?",
  "questionType": "text",
  "answerSelectionType": "multiple",
  "answers": ["namespace keyword", "use keyword", "import keyword", "aliasing"],
  "correctAnswer": [1, 2, 4],
  "messageForCorrectAnswer": "Correct.",
  "messageForIncorrectAnswer": "Incorrect.",
  "explanation": "PHP uses namespace, use, and aliasing; import does not exist in PHP.",
  "point": "2"
},
{
  "question": "Which PHP keyword is used to implement an interface?",
  "questionType": "text",
  "answerSelectionType": "single",
  "answers": ["implements", "extends", "interface", "use"],
  "correctAnswer": "1",
  "messageForCorrectAnswer": "Correct.",
  "messageForIncorrectAnswer": "Incorrect.",
  "explanation": "implements keyword is used to implement interfaces in classes.",
  "point": "2"
},
{
  "question": "Which of the following are PHP traits features?",
  "questionType": "text",
  "answerSelectionType": "multiple",
  "answers": ["reuse code in multiple classes", "cannot be instantiated", "can have methods", "cannot have properties"],
  "correctAnswer": [1, 2, 3],
  "messageForCorrectAnswer": "Correct.",
  "messageForIncorrectAnswer": "Incorrect.",
  "explanation": "Traits allow code reuse, cannot be instantiated, and can contain methods and properties.",
  "point": "2"
},
{
  "question": "Which of the following are PHP string functions?",
  "questionType": "text",
  "answerSelectionType": "multiple",
  "answers": ["strlen()", "str_replace()", "strpos()", "substr()"],
  "correctAnswer": [1, 2, 3, 4],
  "messageForCorrectAnswer": "Correct.",
  "messageForIncorrectAnswer": "Incorrect.",
  "explanation": "All listed functions are valid PHP string functions.",
  "point": "2"
},
{
  "question": "Which operator is used for concatenation in PHP?",
  "questionType": "text",
  "answerSelectionType": "single",
  "answers": ["+", ".", "&", "concat()"],
  "correctAnswer": "2",
  "messageForCorrectAnswer": "Correct.",
  "messageForIncorrectAnswer": "Incorrect.",
  "explanation": "The dot (.) operator concatenates strings.",
  "point": "2"
},
{
  "question": "Which of the following are ways to connect to a MySQL database in PHP?",
  "questionType": "text",
  "answerSelectionType": "multiple",
  "answers": ["mysqli", "PDO", "mysql_connect()", "db_connect()"],
  "correctAnswer": [1, 2, 3],
  "messageForCorrectAnswer": "Correct.",
  "messageForIncorrectAnswer": "Incorrect.",
  "explanation": "mysqli, PDO, and mysql_connect() can connect to MySQL; db_connect() is invalid.",
  "point": "2"
},
{
  "question": "Which function checks if a file exists in PHP?",
  "questionType": "text",
  "answerSelectionType": "single",
  "answers": ["file_exists()", "exists_file()", "is_file()", "check_file()"],
  "correctAnswer": "1",
  "messageForCorrectAnswer": "Correct.",
  "messageForIncorrectAnswer": "Incorrect.",
  "explanation": "file_exists() checks if a file exists.",
  "point": "2"
},
{
  "question": "Which of the following are PHP array search functions?",
  "questionType": "text",
  "answerSelectionType": "multiple",
  "answers": ["in_array()", "array_search()", "array_key_exists()", "array_find()"],
  "correctAnswer": [1,2,3],
  "messageForCorrectAnswer": "Correct.",
  "messageForIncorrectAnswer": "Incorrect.",
  "explanation": "in_array(), array_search(), and array_key_exists() are valid array search functions; array_find() does not exist.",
  "point": "2"
},
{
  "question": "Which PHP function is used to redirect a user to another page?",
  "questionType": "text",
  "answerSelectionType": "single",
  "answers": ["redirect()", "header()", "goto()", "location()"],
  "correctAnswer": "2",
  "messageForCorrectAnswer": "Correct.",
  "messageForIncorrectAnswer": "Incorrect.",
  "explanation": "header('Location: url') is used to redirect users in PHP.",
  "point": "2"
},
{
  "question": "Which of the following are PHP session functions?",
  "questionType": "text",
  "answerSelectionType": "multiple",
  "answers": ["session_start()", "session_destroy()", "session_unset()", "session_close()"],
  "correctAnswer": [1,2,3],
  "messageForCorrectAnswer": "Correct.",
  "messageForIncorrectAnswer": "Incorrect.",
  "explanation": "session_start(), session_destroy(), and session_unset() are valid; session_close() does not exist.",
  "point": "2"
},
{
  "question": "Which of the following are valid ways to define constants in PHP 7+?",
  "questionType": "text",
  "answerSelectionType": "multiple",
  "answers": ["define()", "const keyword", "setConst()", "constant()"],
  "correctAnswer": [1,2],
  "messageForCorrectAnswer": "Correct.",
  "messageForIncorrectAnswer": "Incorrect.",
  "explanation": "Constants can be defined using define() or const; the others are invalid.",
  "point": "2"
},
{
  "question": "Which of the following are valid ways to handle exceptions in PHP?",
  "questionType": "text",
  "answerSelectionType": "multiple",
  "answers": ["try...catch", "throw", "finally", "onError()"],
  "correctAnswer": [1,2,3],
  "messageForCorrectAnswer": "Correct.",
  "messageForIncorrectAnswer": "Incorrect.",
  "explanation": "try...catch, throw, and finally are standard exception handling constructs; onError() does not exist.",
  "point": "2"
},
{
  "question": "Which of the following are valid PHP filter constants?",
  "questionType": "text",
  "answerSelectionType": "multiple",
  "answers": ["FILTER_SANITIZE_STRING", "FILTER_VALIDATE_INT", "FILTER_SANITIZE_EMAIL", "FILTER_CLEAN_INPUT"],
  "correctAnswer": [1,2,3],
  "messageForCorrectAnswer": "Correct.",
  "messageForIncorrectAnswer": "Incorrect.",
  "explanation": "FILTER_SANITIZE_STRING, FILTER_VALIDATE_INT, and FILTER_SANITIZE_EMAIL are valid; FILTER_CLEAN_INPUT does not exist.",
  "point": "2"
},
{
  "question": "Which of the following are valid PHP casting types?",
  "questionType": "text",
  "answerSelectionType": "multiple",
  "answers": ["(int)", "(float)", "(string)", "(boolean)"],
  "correctAnswer": [1,2,3,4],
  "messageForCorrectAnswer": "Correct.",
  "messageForIncorrectAnswer": "Incorrect.",
  "explanation": "All listed types are valid for type casting in PHP.",
  "point": "2"
},
{
  "question": "Which of the following are valid PHP operators for arithmetic?",
  "questionType": "text",
  "answerSelectionType": "multiple",
  "answers": ["+", "-", "*", "/", "%"],
  "correctAnswer": [1,2,3,4,5],
  "messageForCorrectAnswer": "Correct.",
  "messageForIncorrectAnswer": "Incorrect.",
  "explanation": "All listed operators are valid arithmetic operators in PHP.",
  "point": "2"
}
    
  ]
};
